module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-operations"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('openProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'openProjects'),
      expression: "selectedItem === 'openProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('openProjects', $event)
      }
    }
  }), _vm._v(" "), _c('snoozedProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'snoozedProjects'),
      expression: "selectedItem === 'snoozedProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('snoozedProjects', $event)
      }
    }
  }), _vm._v(" "), _c('noInvoiceProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'noInvoiceProjects'),
      expression: "selectedItem === 'noInvoiceProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('noInvoiceProjects', $event)
      }
    }
  }), _vm._v(" "), _c('ongoingProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'ongoingProjects'),
      expression: "selectedItem === 'ongoingProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('ongoingProjects', $event)
      }
    }
  }), _vm._v(" "), _c('claimsProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'openClaims'),
      expression: "selectedItem === 'openClaims'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('openClaims', $event)
      }
    }
  }), _vm._v(" "), _c('coming-soon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'projectsCloseToBudget'),
      expression: "selectedItem === 'projectsCloseToBudget'"
    }]
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e3af40a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/customers/operations.vue
// module id = 847
// module chunks = 0